import { c as _c } from "react/compiler-runtime";
import { useForm } from "react-hook-form";
import Icon from "@/components/icon";
interface FormProps {
  onSubmit: (value: string) => Promise<void>;
  isPending: boolean;
  error?: Error | null;
  disabled?: boolean;
}
interface FormValues {
  profil: string;
}
export const Form: React.FC<FormProps> = t0 => {
  const $ = _c(26);
  const {
    onSubmit,
    isPending,
    error,
    disabled
  } = t0;
  const {
    register,
    handleSubmit,
    reset
  } = useForm();
  let t1;
  if ($[0] !== isPending || $[1] !== onSubmit || $[2] !== reset) {
    t1 = async data => {
      if (isPending) {
        return;
      }
      await onSubmit(data.profil);
      reset();
    };
    $[0] = isPending;
    $[1] = onSubmit;
    $[2] = reset;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== handleSubmit || $[5] !== t1) {
    t2 = handleSubmit(t1);
    $[4] = handleSubmit;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onSubmitForm = t2;
  let t3;
  if ($[7] !== register) {
    t3 = register("profil", {
      required: true
    });
    $[7] = register;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = isPending || disabled;
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <input {...t3} type="text" placeholder={"Saisir le nom de l'activit\xE9 (exemple : comptable)"} className="w-full h-12 pl-4 pr-24 border-grey border rounded placeholder:text-sm placeholder:italic" disabled={t4} />;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = isPending || disabled;
  let t7;
  if ($[12] !== isPending) {
    t7 = isPending ? <Icon icon="time" className="animate-spin" size={16} /> : "Ajouter";
    $[12] = isPending;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <button type="submit" disabled={t6} className="absolute right-1 top-1/2 -translate-y-1/2 bg-primary text-white px-6 py-2 rounded flex items-center justify-center min-w-[100px] h-[36px] disabled:opacity-50">{t7}</button>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== onSubmitForm || $[18] !== t5 || $[19] !== t8) {
    t9 = <form onSubmit={onSubmitForm} className="relative">{t5}{t8}</form>;
    $[17] = onSubmitForm;
    $[18] = t5;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== error) {
    t10 = error && <p className="text-primary text-sm">Une erreur est survenue lors de l'ajout du profil. Veuillez réessayer.</p>;
    $[21] = error;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t9) {
    t11 = <div className="flex flex-col gap-4">{t9}{t10}</div>;
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
};